import { AltLabel } from '../../TreeViewTypes';
import { DataNode, LabelContext } from '../../data_nodes/types';
import { LabelGenerator, DefaultLabelGenerator } from '../types';

/**
 * Generate default label for Dependency nodes
 *
 * Returns: "Dependency N" where N is the dependency index
 */
export const generateDependencyDefaultLabel: DefaultLabelGenerator = (
  dataNode: DataNode<any>,
  context: LabelContext,
): string => {
  try {
    // Extract dependency index from the node data
    const dependencyIndex = dataNode.data?.dependencyIndex || 1;

    return `Dependency ${dependencyIndex}`;
  } catch (error) {
    console.warn('Error generating dependency default label:', error);
    // ✅ Fallback to basic label
    return 'Dependency';
  }
};

/**
 * Generate alt labels for Dependency nodes
 *
 * Dependencies only have one simple format
 */
export const generateDependencyAltLabels: LabelGenerator = (
  dataNode: DataNode<any>,
  context: LabelContext,
): AltLabel[] => {
  const defaultLabel = generateDependencyDefaultLabel(dataNode, context);

  return [
    {
      key: 'default',
      selectOption: 'Default',
      value: defaultLabel,
    },
  ];
};
